import { createSelector } from 'reselect';
import { getGatesFromAuth } from '../selectors/AuthSelector';
import { gate } from 'hub-http/gates';
export const getIsUngatedBetaLanguages = createSelector([getGatesFromAuth], gates => gates.includes(gate('I18n:KO-TH-ZHCN')));